import React, { useMemo, useState } from "react";
import { LayoutChangeEvent, NativeScrollEvent, NativeSyntheticEvent, StyleSheet, View } from "react-native";

export function useMusicScrollIndicator(estimatedContentHeight = 0, opacity = 0.3) {
  const [viewportHeight, setViewportHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);
  const effectiveContentHeight = Math.max(contentHeight, estimatedContentHeight);
  const scrollable = Math.max(0, effectiveContentHeight - viewportHeight);
  const thumbHeight = effectiveContentHeight > viewportHeight
    ? Math.max(36, viewportHeight * viewportHeight / effectiveContentHeight)
    : 0;
  const travel = Math.max(0, viewportHeight - thumbHeight);
  const thumbOffset = scrollable > 0
    ? Math.min(travel, Math.max(0, scrollOffset / scrollable * travel))
    : 0;

  return useMemo(() => ({
    listProps: {
      onLayout: (event: LayoutChangeEvent) => setViewportHeight(event.nativeEvent.layout.height),
      onContentSizeChange: (_width: number, height: number) => setContentHeight(height),
      onScroll: (event: NativeSyntheticEvent<NativeScrollEvent>) => setScrollOffset(event.nativeEvent.contentOffset.y),
      scrollEventThrottle: 16,
      showsVerticalScrollIndicator: false,
    },
    indicator: thumbHeight > 0 ? (
      <View pointerEvents="none" style={styles.track}>
        <View style={[styles.thumb, { height: thumbHeight, backgroundColor: `rgba(255,255,255,${opacity})`, transform: [{ translateY: thumbOffset }] }]} />
      </View>
    ) : null,
  }), [opacity, thumbHeight, thumbOffset]);
}

const styles = StyleSheet.create({
  track: {
    position: "absolute",
    top: 2,
    right: 1,
    bottom: 2,
    width: 8,
    zIndex: 20,
    alignItems: "center",
  },
  thumb: {
    width: 6,
    borderRadius: 3,
    backgroundColor: "rgba(255,255,255,0.30)",
  },
});
